import { FC } from 'react';

import type { Block } from '@eluve/llm-outputs';
import { DynamicArtifactRenderer } from '@eluve/smart-blocks';

export interface DynamicArtifactComponentRendererProps {
  blocks: Block[];
}

export const DynamicArtifactComponentRenderer: FC<
  DynamicArtifactComponentRendererProps
> = ({ blocks }) => {
  return <DynamicArtifactRenderer isReadonly={true} blocks={blocks} />;
};
